module.exports = __webpack_public_path__ + "static/img/360security.197610e9.png";